import React from 'react';
import PropTypes from 'prop-types';
import Svg from "../Svg";

const IconServiceRent = () => (
	<div className="icon-service icon-service-rent">
		<Svg height={25} width={25} viewBox={`25 25`}>
			<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-13.000000, -13.000000)">
				<path
					transform="scale(0.9)"
					d="M25.1254505,19.7593853 L31.5102708,22.6115824 L30.1867022,27.0203707 L28.1454239,30.5725677 L29.8791123,30.5725677 L31.3518154,27.9897448 L32.572854,28.5583201 L31.2679272,30.9258301 L32.9550111,30.9258301 L33.9150644,29.1921416 L34.6327741,29.5276942 C35.1454239,29.7607169 35.4996183,30.2267622 35.5835064,30.7860165 L35.5835064,30.7860165 L35.9936263,33.39587 L21.9936263,33.39587 L22.0309099,29.0523281 L22.8466263,26.6013853 L24.3421237,27.1763065 L24.8796756,25.7759359 L23.3206263,25.1773853 L23.6636263,24.1473853 L26.3421237,25.1763065 L26.8796756,23.7759359 L24.1376263,22.7233853 L25.1254505,19.7593853 Z"
					fill="#FFFFFF"/>
			</g>
		</Svg>
	</div>
);

IconServiceRent.defaultProps = {
	fill: '#ffffff'
};

IconServiceRent.propTypes = {
	fill: PropTypes.string
};

export default IconServiceRent;
